/**
 * @def Defines available BusinessUnits for the application.
 */
export enum BusinessUnit {
  Mock = 'mock',
  US = 'us',
  PL = 'pl',
  NO = 'no',
  SE = 'se',
  DK = 'dk',
  LV = 'lv',
  LT = 'lt',
  EE = 'ee',
  CA = 'ca',
  DE = 'de',
  BE = 'be',
  LU = 'lu',
  NL = 'nl',
}

export const DEFAULT_BUSINESS_UNIT = BusinessUnit.US;
